<template>
  <!-- Inovices card -->
  <div class="position-relative">
    <div
      v-if="walletBalance"
      class="row d-flex flex-nowrap overflow-auto disable_line"
    >
      <div class="col-xl-2 col-lg-4 col-6 d-flex" v-if="settings === 'NGN'">
        <div class="card inovices-card w-100">
          <div
            class="card-body d-flex flex-column justify-content-between h-100"
          >
            <div class="dash-widget-header">
              <span class="inovices-widget-icon bg-info-light">
                <i class="fas fa-naira-sign"></i>
              </span>
              <div class="dash-count">
                <div class="dash-title">Naira</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="dash-widget-header">
                <div class="dash-count">
                  <div class="dash-counts">
                    <p style="font-size: 16px">
                      {{ `NGN ${addCurrencyComma(walletBalance?.NGN)}` }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-lg-4 col-6 d-flex">
        <div class="card inovices-card w-100">
          <div
            class="card-body d-flex flex-column justify-content-between h-100"
          >
            <div class="dash-widget-header">
              <span class="inovices-widget-icon bg-green-light">
                <i class="fas fa-dollar-sign"></i>
              </span>
              <div class="dash-count">
                <div class="dash-title">US Dollar</div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="dash-widget-header">
                <div class="dash-count">
                  <div class="dash-counts">
                    <p style="font-size: 16px">
                      {{ `USD ${addCurrencyComma(walletBalance?.USD)}` }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Inovices card -->
</template>

<script setup>
import { addCurrencyComma } from "@/assets/composables/currency";
import { onMounted, computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const settings = computed(() => {
  return store.getters["settings/settings"]?.currency;
});

const walletBalance = computed(() => {
  return store.getters["transaction/walletBalance"].balance;
});

const getWalletBalance = () => {
  store.dispatch("transaction/getWalletBalance");
};

onMounted(() => {
  getWalletBalance();
});
</script>

<style>
.disable_line::-webkit-scrollbar {
  display: none;
}
</style>
